






import { computed, PropType, defineComponent } from '@vue/composition-api';

import { useFetchWorkflowFormTemplateRevisionsStakeholderUsers } from '@/composable/workflow-form-template';

import { IUser } from '@/models';

export default defineComponent({
  name: 'WorkflowFormTemplateStakeholderUserProvider',

  props: {
    stakeholderUsers: {
      type: Array as PropType<(IUser | number)[]>
    }
  },

  setup(props) {
    const { users } = useFetchWorkflowFormTemplateRevisionsStakeholderUsers();

    const computedStakeholderUsers = computed<IUser[]>(() => {
      let usersList: IUser[] = [];

      usersList = props.stakeholderUsers!.map(
        (stakeholderUser: number | IUser) => {
          if (typeof stakeholderUser === 'number') {
            return users.value.find(user => stakeholderUser === user.id!)!;
          } else {
            return stakeholderUser;
          }
        }
      );

      return usersList;
    });

    return { computedStakeholderUsers };
  }
});
